'use client'
import React, {useEffect, useState} from "react";
import {backgroundColor} from "@/constants/constants";
import {tv} from "tailwind-variants";
import clsx from "clsx";

const generateClasses = tv({
    slots: {
        root: [
            'z-10 sticky top-[-1px] mt-2xl md:mt-3xl',
            'flex flex-wrap gap-mobile md:gap-2xl lg:gap-3xl max-w-full ',
            'px-mobile md:px-2xl lg:px-3xl'
        ],
        color: '',
    },
    variants: {
        backgroundColor: {
            'peach': {
                color: 'bg-brand-peach'
            },
            'light-peach': {
                color: 'bg-brand-light-peach'
            },
            'purple':{
                color: 'bg-brand-purple'
            },
            'light-purple':{
                color: 'bg-brand-light-purple'
            },
            'blue':{
                color: 'bg-brand-blue'
            },
            'light-blue':{
                color: 'bg-brand-light-blue'
            },
            'warm-grey':{
                color: 'bg-brand-warm-grey'
            },
            'light-warm-grey':{
                color: 'bg-brand-light-warm-grey'
            },
            'cool-grey':{
                color: 'bg-brand-cool-grey'
            },
            'light-cool-grey':{
                color: 'bg-brand-light-cool-grey'
            },
            'green': {
                color: 'bg-brand-green'
            },
            'light-green': {
                color: 'bg-brand-light-green'
            }
        }
    },
});

interface Props {
    backgroundColor?: backgroundColor
}

export default function AnchorNavigation({backgroundColor}: Props) {
    const {root, color} = generateClasses({
        backgroundColor
    });

    const [anchors, setAnchors] = useState<Element[]>([]);
    useEffect(() => {
        const anchorElements = Array.from(document.querySelectorAll('.anchor-title'));
        if (!anchorElements.length) return;

        setAnchors(anchorElements);

        let lastScrollTop = 0;

        document.addEventListener('scroll', function() {
            let activeIndex = -1;
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

            anchorElements.forEach((element, index) => {
                const rect = element.getBoundingClientRect();
                if (rect.top <= window.innerHeight / 2 && rect.bottom >= window.innerHeight / 2) {
                    activeIndex = index;
                }
            });

            const links = (document.querySelectorAll('.anchor-link'));
            if (activeIndex !== -1) {
                removeActiveClass(links);
                addActiveClasses(links[activeIndex])
            } else if (scrollTop < lastScrollTop) {
                for (let i = anchorElements.length - 1; i >= 0; i--) {
                    const rect = anchorElements[i].getBoundingClientRect();
                    if (rect.bottom < window.innerHeight / 2) {
                        removeActiveClass(links);
                        addActiveClasses(links[i])
                        break;
                    }
                }
            }

            lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
        });

        const addActiveClasses = (link:Element) => {
            if(!link) return;
            link.classList.add('font-bold');
            link.classList.remove('border-transparent');
            link.classList.remove('text-black/60');
        }

        const removeActiveClass = (links:NodeListOf<Element>) => {
            links.forEach((link) => {
                if(!link) return;
                link.classList.remove('font-bold');
                link.classList.add('border-transparent');
                link.classList.add('text-black/60');
            });
        };
    }, []);

    return (
        <>
            <div
                className={clsx(root(), color())}>
                <ul className="w-max m-auto flex items-center flex-nowrap list-none h-fit overflow-x-auto">
                    {anchors.map((anchor, index) => (
                        <li key={index}
                            className={clsx('border-b-[3px] mx-xl min-w-max anchor-link border-transparent text-black/60')}>
                            <a href={`#${anchor.id}`} className="py-l block group focus:outline-0 brand-transition hover:text-black hover:font-semibold focus:text-black focus:font-semibold">
                                <span className="group-focus:outline-offset-[5px] group-focus:outline-2 group-focus:outline-outline group-focus:outline">
                                    {anchor.textContent}
                                </span>
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        </>
    )
}